<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/suQuHJ/OEBPS/images/9781443128131_Outside_Front_Cover.jpg?1684514749051" alt="This image is the cover for the book Dear Canada: A Rebel's Daughter, Dear Canada"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Dear Canada: A Rebel's Daughter, Dear Canada
      </h1>
      <p class="bookDescription body article font2">
        <p>After Arabella's father is jailed for his part in the short-lived 1837 Upper Canada Rebellion in Toronto, her mother just cannot cope. The family is ostracized, they lose their home and they have no income - yet Arabella's mother still doesn't take action. So it is up to twelve-year-old Arabella to find new lodgings and to get employment so they have money to live on. And as if that weren't enough to worry about, her older brother Charlie has vanished. </p><p> Readers will cheer for the heroine in this "riches to rags" story as Arabella struggles to keep her family afloat while awaiting her father's release from prison. <i>A Rebel's Daughter</i> includes an Historical Note giving readers the cultural context of the Upper Canada Rebellion, a map showing 1837 Toronto, as well as fascinating documents and photographs from this pivotal time period.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Janet Lunn
      </h2>
      
      <p class="authorDescription body article"><b>JANET LUNN</b>'s children's books always make award and bestseller lists. She hase been awarded the Writers' Trust Matt Cohen Award in Celebration of a Writing Life and the Order of Ontario, and she is also a member of the Order of Canada. Lunn's history of Canada, <i>The Story of Canada</i>, is a must-have reference book for teachers and parents across the country.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Scholastic Canada Ltd.
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?cf6f7c7e